<template>
  <section class="bg-dark py-2" aria-label="favourites and saved searches">
    <b-container>
      <b-row>
        <save-search-component
          v-if="displaySavedSearch"
          :selected-filters="selectedFilters"
        ></save-search-component>
        <view-favourites></view-favourites>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import ViewFavourites from '@/components/favourite_list/ViewFavourites.vue'
import SaveSearchComponent from '@/components/save_search/SaveSearchComponent.vue'

export default {
  name: 'UserActionsComponent',
  components: {
    ViewFavourites,
    SaveSearchComponent,
  },
  props: {
    selectedFilters: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    displaySavedSearch() {
      if (this.$route.name == 'Search') return true
      return false
    },
  },
}
</script>
